import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import CircleBackground from '../components/general/CircleBackground';
import { INFO_BACKGROUND_COLOR, DARK_BLUE_COLOR } from '../components/general/constants/_colors';

// components that check useNewLogin should be updated when PasswordlessLogin.Splash & the msr_login_app_dl_banners flag are removed

const StyledSplash = styled.div`
  background-color: ${props => (props.useNewLogin ? INFO_BACKGROUND_COLOR : DARK_BLUE_COLOR)};
  color: #fff;
  text-align: center;
  height: 100%;
  min-height: 815px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ContentContainer = styled.div`
  margin: 40px;
  flex-grow: 2;
  display: flex;
  align-items: center;
  max-width: ${props => (props.useNewLogin ? '560px' : '480px')};

  > div {
    width: 100%;
  }
`;

const Splash = ({ children, useNewLogin }) => (
  <StyledSplash useNewLogin={useNewLogin}>
    <ContentContainer useNewLogin>
      <div>{children}</div>
    </ContentContainer>
    {!useNewLogin && <CircleBackground height="150px" width="90%" color="white" />}
  </StyledSplash>
);

Splash.propTypes = {
  children: PropTypes.node.isRequired,
  useNewLogin: PropTypes.bool,
};

Splash.defaultProps = {
  useNewLogin: false,
};

export default Splash;
